import { render } from "./InspectionReasonInterruptedForm.vue?vue&type=template&id=c180d4f2"
import script from "./InspectionReasonInterruptedForm.vue?vue&type=script&lang=js"
export * from "./InspectionReasonInterruptedForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__